import * as React from 'react'

/** Runtime companion to the `max-pane` variant derived from `--breakpoint-pane`. */
export const MAX_PANE_MEDIA_QUERY = '(max-width: 899px)'

export function useMediaQuery(query: string, fallback = false): boolean {
  const subscribe = React.useCallback(
    (cb: () => void) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {}
      const mql = window.matchMedia(query)
      mql.addEventListener('change', cb)
      return () => mql.removeEventListener('change', cb)
    },
    [query],
  )
  return React.useSyncExternalStore(
    subscribe,
    () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : fallback),
    () => fallback,
  )
}

/** Below 900px the shell collapses to one pane with bottom tabs (scope §5.0). */
export function useIsSinglePane(): boolean {
  return useMediaQuery(MAX_PANE_MEDIA_QUERY)
}
